import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  padding: 20px;
  text-align: center;
  border: 1px solid #ff6b6b;
  border-radius: 4px;
  background-color: #ffe0e0;
  color: #d63031;
  margin: 10px 0;
`;

const ErrorTitle = styled.h3`
  margin: 0 0 10px 0;
  color: #d63031;
`;

const ErrorMessage = styled.p`
  margin: 0 0 15px 0;
  font-size: 14px;
`;

const RetryButton = styled.button`
  background-color: #0984e3;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background-color: #0770c4;
  }
`;

class PdfErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error for debugging
    console.error('PDF Error Boundary caught an error:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleRetry = () => {
    // Reset the error boundary state
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      // Check if this is the specific PDF.js worker transport error
      const isWorkerTransportError = this.state.error?.message?.includes('sendWithPromise') ||
                                   this.state.error?.stack?.includes('WorkerTransport.getPage');

      return (
        <ErrorContainer>
          <ErrorTitle>PDF Loading Error</ErrorTitle>
          <ErrorMessage>
            {isWorkerTransportError 
              ? "The PDF viewer encountered a technical issue. This sometimes happens when navigating quickly between forms."
              : `Something went wrong while loading the PDF: ${this.state.error?.message || 'Unknown error'}`
            }
          </ErrorMessage>
          <RetryButton onClick={this.handleRetry}>
            Try Again
          </RetryButton>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default PdfErrorBoundary;
